import React, {  } from "react";
import ContestDetailsInfo from "./ContestDetailsInfo";
import ContestPlayers from "./ContestPlayers";
import { useParams } from "react-router";

const ContestDetails = () => {
  const params = useParams();
  const contestId = params?.id
  
  return (
    <div class="content">
      <div className="content-inner">

      <div class="row gy-4">
        <ContestDetailsInfo contestId={contestId}/>
        <ContestPlayers contestId={contestId}/>
      </div>
      </div>
    </div>
  );
};

export default ContestDetails;
